import script from "./LoanApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./LoanApplication.vue?vue&type=script&setup=true&lang=js"

import "./LoanApplication.vue?vue&type=style&index=0&id=003f5633&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003f5633"]])

export default __exports__